import api from '@/api'

export default function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  plugin.installed = true

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$api = api
}
